import { openTheModal } from "../functions";
import { nameInput, goodIdInput } from "../forms/payment-form/elements";
import axios from "axios";

import store from "../forms/payment-form/store";

if (window.location.pathname === "/payment") {
    const url = new URL(window.location.href);
    if (url.searchParams.has("lead_id")) openTheModal('[data-target="thank"]');

    writeLeadData();

    function writeLeadData() {
        const storageLeadData = sessionStorage.getItem("leadData");
        if (!storageLeadData) return;
        const leadData = JSON.parse(storageLeadData);
        if (!leadData) return;

        // bpEmailInput.value = leadData.email;
        // fpEmailInput.value = leadData.email;
        nameInput.value = leadData.name;
        // bpNameInput.value = leadData.name;
        // fpNameInput.value = leadData.name;
        // bpTelegramInput.value = leadData.telegram;
        // fpTelegramInput.value = leadData.telegram;
    }

    axios
        .get(
            `${window.location.origin}/payment/price?good_id=${goodIdInput.value}`
        )
        .then((res) => {
            store.initialPrices = res.data;
        });
}
